export const linkResolver = (props) => {
  // console.log('👾 linkResolver > ', props)

  if (props.type === 'home') {
    return `/`
  }
  if (props.type === 'collection') {
    return `/collections/${props.uid}`
  }
  if (props.type === 'product') {
    return `/products/${props.uid}`
  }
  if (props.type === 'page') {
    return `/${props.uid}`
  }
  if (props.type === 'post') {
    return `/blog/${props.uid}`
  }

  return `/${props.uid}`
}
